import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "@/store/slices/cartSlice";
import uiReducer from "@/store/slices/uiSlice";
import orderReducer from "@/store/slices/orderSlice";
import customerReducer from "@/store/slices/customerSlice";

export function makeStore() {
  return configureStore({
    reducer: {
      cart: cartReducer,
      ui: uiReducer,
      order: orderReducer,
      customer: customerReducer,
    },
  });
}
